(function ($) {
  Drupal.behaviors.onlineServicesBlockV1 = {
    attached: false,

    attach: function (context, settings) {
      if (this.attached) {
        return;
      }

      this.attached = true;

      var $templates = $('.online-services-block[data-url]', context);

      $templates.each(function () {
        $(this).once().click(function () {
          window.location = $(this).data('url');
        });
      });
    }
  };
})(jQuery);
